module.exports = __webpack_public_path__ + "static/media/refer_an_friend.916127a6.png";